exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feedback-block {\n  margin-top: 20px;\n}\n.feedback-block:first-child {\n  margin-top: 0;\n}\n.feedback-table thead tr th:first-child {\n  width: 160px;\n}\n", ""]);

// exports
